module.exports = __webpack_public_path__ + "static/media/informativa_privacy_candidati.3f8f15b6.pdf";